import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './onboarding/onboardingStyles.css'
import App from './App.jsx'
import { AuthProvider } from './contexts/AuthContext.jsx'
import { LanguageProvider } from './contexts/LanguageContext.jsx'
import { HashRouter } from 'react-router-dom'
import { installConsoleCapture } from './utils/consoleCapture.js'

installConsoleCapture({ max: 400 })

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AuthProvider>
      <LanguageProvider>
        <HashRouter>
          <App />
        </HashRouter>
      </LanguageProvider>
    </AuthProvider>
  </StrictMode>
)